import type { TranslationInterface } from './translation.types';

export const esLocale: TranslationInterface = {
  'write-a-message': 'Escribe un mensaje...',
  'session-closed-lead': '¡Tu problema fue resuelto!',
  'new-conversation': 'Nueva conversación',
  'welcome-title': 'Bienvenido a nuestro chat de soporte',
  'welcome-description':
    '¡Estamos aquí para ayudarte! Inicia una conversación y responderemos lo antes posible.',
  'your-name': 'Tu nombre',
  'your-email': 'Tu correo electrónico',
  'start-chat': 'Hablar con soporte',
  'starting-chat': 'Conectando...',
  'i-need-more-help': 'Necesito más ayuda',
  'this-was-helpful': 'Esto fue útil',
  optional: 'Opcional',
  'no-conversations-yet': 'Sin conversaciones aún',
  'back-to-conversations': 'Volver a conversaciones',
  'closed-conversations': 'Conversaciones cerradas',
};
